/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.list.controllers', [
  'ui.router',
  'ui.grid',
  'ui.grid.autoResize',
  'ui.grid.selection',
  'ui.grid.pagination',
  'ui.grid.resizeColumns',
  'ui.grid.edit',
  'ui.grid.grouping',
  'ui.grid.draggable-rows',
  'ui.grid.moveColumns',
  'ui.grid.saveState',
  'acme.common.service.api',
  'acme.common.service.venue',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.factory.gridState',
  'acme.common.factory.gridDefinition',
  'acme.common.service.viewState'
])
.controller('PartnersListController', ['$scope', '$state', '$filter', '$timeout', 'ApiService', 'VenueService', 'HelpersService', 'CalendarService', 'GridStateFactory', 'ViewStateService', 'GridDefinitionFactory', function($scope, $state, $filter, $timeout, ApiService, VenueService, HelpersService, CalendarService, GridStateFactory, ViewStateService, GridDefinitionFactory) {

    $scope.partnersList = {
      model: [],
      categorized: [],
      categories: [],
      searchQuery: ViewStateService.getStateProperty('partners.list', 'searchQuery', ''),
      queryTimer: false,
      gridState: new GridStateFactory(),
      gridDefinition: new GridDefinitionFactory(),
      isLoaded: false,

      getStatusLabel: VenueService.getStatusLabel,
      selectedCategory: null,
      organizationName: '',
      contactName: '',

      optionsOverride: {
        data: 'partnersList.model',
        appScopeProvider: {
          onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
            $scope.partnersList.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
          },
          onDataGridSortChange: function(grid, columns, page) {
           $scope.partnersList.onDataGridSortChange(grid, columns, page);
          },
          onDblClick: function (item) {
            $scope.partnersList.onDblClick(item);
          },
          createOrder: function(item) {
            $scope.partnersList.createOrder(item);
          }
        },
        columnDefs: [
          {
            field: 'view',
            displayName: 'View',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.partnersList.optionsOverride.appScopeProvider.onDblClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.company.name }}</span></a></div>'
          },
          {
            field: 'company.name',
            displayName: 'Organization',
            colId: 'name',
            sort: { direction: 'asc'}
          },
          {
            field: 'primaryContact.contactName',
            displayName: 'Primary Contact',
            colId: 'contactName'
          },
          {
            field: 'company.phoneNumber',
            displayName: 'Phone',
            colId: 'phoneNumber'
          },
          {
            field: 'company.city',
            displayName: 'City',
            colId: "city",
            enableSorting: false
          },
          {
            field: 'company.state',
            displayName: 'State',
            colId: "state",
            enableSorting: false
          },
          {
            field: 'accountCategoryRelation.categoryName',
            displayName: 'Category',
            colId: "categoryName"
          },
          {
            field: 'reseller.status',
            displayName: 'Reseller',
            colId: "status",
            enableSorting: false
          },
          {
            field: 'company.organizationId',
            displayName: 'Order',
            onCellNavClick: function(row, col) {
              $scope.partnersList.optionsOverride.appScopeProvider.createOrder(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents partners-list-order"><a title="Create Order" data-ng-click="grid.appScope.createOrder(row.entity)" class="partners-list-order-link fa fa-ticket" role="button"></a></div>',
            width: 40,
            enableHiding: false,
            colId: "id"
          }
        ]
      },

      viewId: '',

      accountsListGridName: $state.current.name+'.grid0',

      init: function() {

        this.viewId = $state.current.name;

        this.getCategories();

        $scope.$on('DataGrid::UserPreferencesLoaded', function() {
          var self = $scope.partnersList,
            props = self.gridDefinition.getGridState();

          self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
          self.initData();
        });

        this.gridDefinition.init(this.accountsListGridName, this.optionsOverride || {}, this.viewId, $state.current.data.enablePreferences);

        $scope.$emit('Application::contentTitleChange', {
          title: 'Organizations',
          buttonRight: {
            permissions: 'ACCT_CREATE',
            label: 'Create Organization',
            action: function() {
              $scope.partnersList.create();
            }
          }
        });

        this.addHandlers();

        $scope.$on('destroy', function() {
          var self = $scope.partnersList;
          $timeout.cancel(self.queryTimer);
        });
      },

      addHandlers: function() {
        //remember view state
        $scope.$on('pageContent::startLoad', function(event, data) {
          var self = $scope.partnersList;

          if (data && data.from && data.from.name === 'application.partners.list.default') {
            switch (data.to.name) {
              case 'application.partners.detail':
              case 'application.orders.create':
                break;

              default:
                ViewStateService.resetState('partners.list');
            }
          }
        });

      },

      createOrder: function(item) {
        var self = $scope.partnersList;

        ViewStateService.setState('partners.list', {
          searchQuery: self.searchQuery,
          selectedCategory: self.selectedCategory,
          page: self.gridState.getPropertyValue('page')
        });

        $state.go('application.orders.create', { accountId: item.company.organizationId });
      },

      onDataGridPaginate: function(newPageNumber, newPageSize, sortField, sortDirection) {
        var self = $scope.partnersList;

        self.gridState.updateGridState(newPageNumber, newPageSize);

        if (sortField) {
          self.gridState.updateGridState(null, null, sortField, null);
        }
        if (sortDirection) {
          self.gridState.updateGridState(null, null, null, sortDirection);
        }
        self.setDataForGrid();
      },

      onDataGridSortChange: function(grid, columns, page) {
        var self = $scope.partnersList,
          data = columns[0];

          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.setDataForGrid();
      },

      getCategories: function() {
        ApiService.partners.categories.list(HelpersService.getPaginator()).then(this.success.getCategories, this.error.getCategories);
      },

      initData: function() {
         this.setDataForGrid();
      },

      approve: function(requestId, index) {
        ApiService.partners.approve(requestId).then(function(response) {
          $scope.partnersList.model[index].status = response.data.payload.status;
          $scope.partnersList.success.approve.apply($scope, arguments);
        }, function() {
          $scope.partnersList.error.approve.apply($scope, arguments);
        });
      },

      decline: function(requestId, index) {
        ApiService.partners.decline(requestId).then(function(response) {
          $scope.partnersList.model[index].status = response.data.payload.status;
          $scope.partnersList.success.decline.apply($scope, arguments);
        }, function() {
          $scope.partnersList.error.decline.apply($scope, arguments);
        });
      },

      create: function() {
        if (this.selectedCategory && this.selectedCategory.id) {
          $state.go('application.partners.create', { categoryId: this.selectedCategory.id });
        }else{
          $state.go('application.partners.create');
        }
      },

      hasPartners: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },

      hasCategorized: function() {
        return (this.categorized instanceof Array && this.categorized.length > 0);
      },

      hasCategories: function() {
        return (this.categories instanceof Array && this.categories.length > 0);
      },

      process: function(partners) {
        var i, ii,
            j, jj;

        for (i=0,ii=partners.length;i<ii;i++) {
          if (partners[i].primaryContact) {
            partners[i].primaryContact.contactName = '';
            if (partners[i].primaryContact.firstName) {
              partners[i].primaryContact.contactName = partners[i].primaryContact.firstName;
            }
            if (partners[i].primaryContact.lastName) {
              partners[i].primaryContact.contactName += ' ' + partners[i].primaryContact.lastName;
            }
          }else{
            console.log('PartnersListController:process !partners[i].primaryContact', partners[i]);
            partners[i].primaryContact = {};
            partners[i].primaryContact.contactName = '';
          }
          for (j=0,jj=partners[i].requests.length;j<jj;j++) {
            partners[i][partners[i].requests[j].type] = {
              status: HelpersService.cap(partners[i].requests[j].status)
            };
          }
        }

        return partners;
      },

      processSearch: function(list) {
        return list.map(function(item) {
          var name = [];
          item.name = item.organizationName;
          return {
            accountCategoryRelation: {categoryName: item.category},
            company: item,
            primaryContact: {
              contactName: item.firstName + ' ' + item.lastName
            },
            request: {},
            reseller: {
              status: HelpersService.capFirstLetter(item.reseller)
            }
          };
        });
      },

      isOrgSearchDisabled: function () {
        return (
          ( this.organizationName.length > 0 &&  this.organizationName.length < 3 ) ||
          ( this.contactName.length > 0 &&  this.contactName.length < 3 )
        );
      },

      setDataForGrid: function() {
        var self = $scope.partnersList,
            props = self.gridState.getGridState();

        this.isLoaded = false;

        props.category = this.selectedCategory ? this.selectedCategory.name : '';
        props.organizationName = this.organizationName;
        props.contactName = this.contactName;

        ApiService.organizations.searchOrganizations(props).then(this.success.init, this.error.init);
      },

      query: function() {
        $scope.$broadcast('DataGrid::Search', {name: this.accountsListGridName});
      },

      success: {
        init: function(response) {
          var self = $scope.partnersList;

          self.model = self.processSearch(response.data.payload.list);

          self.categorized = angular.copy(self.model);
          self.isLoaded = true;
          self.gridDefinition.isLoaded = true;
          $timeout(function() {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: self.gridDefinition.options.gridName,
              datasetLength: self.model.length,
              totalItems: response.data.payload.pagination.count
            });
          }, 10);
        },

        approve: function(response) {},

        decline: function(response) {},

        getCategories: function(response) {
          var self = $scope.partnersList, category = ViewStateService.getStateProperty('partners.list', 'selectedCategory', ''), i, ii;

          self.categories = response.data.payload.list;

          if (category && category.id) {
            for (i = 0, ii = self.categories.length; i < ii; i++) {
              if (self.categories[i].id === category.id) {
                self.selectedCategory = self.categories[i];
                break;
              }
            }
          }
          $scope.$on('$destroy', $scope.$watch('partnersList.selectedCategory', self.onSelectedCategoryUpdate));

        }
      },

      error: {
        init: function(response) {
          $scope.partnersList.isLoaded = true;
        },

        approve: function(response) {},

        decline: function(response) {},

        getCategories: function(response) {
          $scope.partnersList.initData();
        }
      },

      onDblClick: function(params) {
        var self = $scope.partnersList;

        ViewStateService.setState('partners.list', {
          searchQuery: self.searchQuery,
          selectedCategory: self.selectedCategory,
          page: self.gridState.getPropertyValue('page')
        });

        $state.go('application.partners.detail', { id: params.entity.company.organizationId });
      },

      onSelectedCategoryUpdate: function(n, o) {
        if (n !== o) {
          ViewStateService.setStateProperty('partners.list','page', 0);
          $scope.partnersList.setDataForGrid();
        }
      }

    };

    $scope.partnersList.init();

}]);
